import React, { Component } from 'react'

import SurveyController from 'modules/Controllers/Survey/SurveyController'
import APPURL from 'utils/app/urls'

class SurveyControllerContainer extends Component {
  constructor(props) {
    super(props)
    this.SECONDS_TO_APPEAR = 120
    this.state = {
      timeLeftToOpen: this.SECONDS_TO_APPEAR,
      shouldOpen: false
    }
  }

  componentDidMount() {
    let enterTime = sessionStorage.getItem('surveyEnterTime')
    let alreadyShown = sessionStorage.getItem('surveyAlreadyShown') === 'true' ? true : false
    let reachedLayer2 = sessionStorage.getItem('surveyReachedLayer2') === 'true' ? true : false
    let timesShown = Number(localStorage.getItem('surveyTimesShown'))
    const currentURL = this.props.match.url
    const currentLayer = APPURL.getLayerFromURL(currentURL)

    if (!enterTime) {
      enterTime = new Date()
      alreadyShown = false
      reachedLayer2 = currentLayer > 1
      if (!timesShown) timesShown = 0

      sessionStorage.setItem('surveyEnterTime', enterTime)
      sessionStorage.setItem('surveyAlreadyShown', alreadyShown)
      sessionStorage.setItem('surveyReachedLayer2', reachedLayer2)
      localStorage.setItem('surveyTimesShown', timesShown)
    }

    if (currentLayer > 1) {
      reachedLayer2 = true
      sessionStorage.setItem('surveyReachedLayer2', reachedLayer2)
    }

    if (timesShown >= 3) {
      this.setState({ shoulOpen: false })
    } else {
      const now = new Date().getTime()
      const then = new Date(enterTime).getTime()
      let timeDifference = (now - then) / 1000
      let timeLeftToOpen = this.SECONDS_TO_APPEAR - timeDifference

      if (!alreadyShown && reachedLayer2) {
        if (timeLeftToOpen < 5) {
          this.setState({
            timeLeftToOpen: 5,
            shouldOpen: true
          })
        } else {
          this.setState({
            timeLeftToOpen: timeLeftToOpen,
            shouldOpen: true
          })
        }
      }
    }
  }

  renderIfAllOK() {
    return <SurveyController shouldOpen={this.state.shouldOpen} timeLeftToOpen={this.state.timeLeftToOpen} />
  }

  render() {
    return <React.Fragment>{this.renderIfAllOK()}</React.Fragment>
  }
}

export default SurveyControllerContainer



// WEBPACK FOOTER //
// ./src/modules/Controllers/Survey/SurveyControllerContainer/SurveyControllerContainer.jsx